import { Col, Container, Row } from "reactstrap";
import { P, SVG } from "../../AbstractElements";

const Footer = () => {
  return (
    <footer className="footer">
      <Container fluid>
        <Row>
          <Col md="6" className="footer-copyright m-0">
            <P className="mb-0 f-w-600">
              Copyright 2024 © wool theme by pixelstrap
            </P>
          </Col>
          <Col md="6" className="text-end">
            <P className="m-0 f-w-600">
              Hand crafted & made with 
              <SVG iconId='heart' className="footer-icon ms-1" />
            </P>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
